'use client';

import { config } from '@/config';
import { Environment } from '@/types/enums/environment';
import { devtools } from 'zustand/middleware';

interface SafeStorage {
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
    removeItem(key: string): void;
}

export const applyDevtools = (config.nodeEnv === Environment.Production
    ? (fn: unknown) => fn
    : devtools) as unknown as typeof devtools;

export const safeSessionStorage: SafeStorage = {
    getItem(key: string) {
        try {
            return sessionStorage.getItem(key);
        } catch (error) {
            return null;
        }
    },
    setItem(key: string, value: string) {
        try {
            sessionStorage.setItem(key, value);
        } catch (error) {
            // Handle error
        }
    },
    removeItem(key: string) {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            // Handle error
        }
    },
};

export const safeCookieStorage: SafeStorage = {
    getItem(key: string) {
        if (typeof window === 'undefined') return null;

        const result = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
        return result && result.length > 0 ? (result.pop() as string) : null;
    },
    setItem(key: string, value: string) {
        if (typeof window === 'undefined') return;

        document.cookie = `${key}=${value};path=/`;
    },
    removeItem(key: string) {
        if (typeof window === 'undefined') return;

        document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
};
